import { forwardRef } from 'react';

/** Props do componente Slider */
export interface SliderProps {
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
  readonly value?: number;
  readonly defaultValue?: number;
  readonly disabled?: boolean;
  readonly onChange?: React.ChangeEventHandler<HTMLInputElement>;
  readonly name?: string;
  readonly id?: string;
  readonly className?: string;
  readonly 'aria-label'?: string;
  readonly 'aria-describedby'?: string;
  readonly 'aria-valuetext'?: string;
}

/**
 * Componente Slider — input de intervalo numérico.
 *
 * @example
 * ```tsx
 * <Slider
 *   min={0}
 *   max={100}
 *   value={completeness}
 *   onChange={(e) => setCompleteness(Number(e.target.value))}
 *   aria-label="Completude (%)"
 * />
 * ```
 */
export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  (
    {
      min = 0,
      max = 100,
      step = 1,
      value,
      defaultValue,
      disabled,
      onChange,
      name,
      id,
      className,
      ...ariaProps
    },
    ref,
  ) => {
    return (
      <input
        ref={ref}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        defaultValue={defaultValue}
        disabled={disabled}
        onChange={onChange}
        name={name}
        id={id}
        className={[
          'w-full cursor-pointer accent-ctx-content-primary',
          'disabled:cursor-not-allowed disabled:opacity-medium',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...ariaProps}
      />
    );
  },
);

Slider.displayName = 'Slider';
